export enum LendingPlanEnum {
  SEED = 'seed',
  SPROUT = 'sprout',
  HARVEST = 'harvest',
}
